import { EmployeeInviteCreateForm, EmployeeInviteList, EmployeeList } from "modules/company";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { api } from "shared/api";
import { Tabs } from "shared/ui";
import { CompanySettingsLayout } from "./_layout";

const CompanyUsersPage = () => {
  const { query } = useRouter();
  const companySlug = query.company as string;
  const [selected, setSelected] = useState("employees");

  const employeeList = api.companyEmployee.useCompanyEmployeeList(companySlug);
  const employeeInviteList = api.companyEmployeeInvite.useCompanyEmployeeInviteList(companySlug);

  return (
    <CompanySettingsLayout>
      <EmployeeInviteCreateForm companySlug={companySlug} />

      <div>
        <Tabs
          tabs={[
            { value: "employees", title: <>Сотрудники {employeeList.data && <>({employeeList.data?.length})</>}</> },
            {
              value: "invites",
              title: (
                <>Отправленные приглашения {employeeInviteList.data && <>({employeeInviteList.data?.length})</>}</>
              ),
            },
          ]}
          selected={selected}
          setSelected={setSelected}
        />

        {selected === "employees" && <EmployeeList companySlug={companySlug} {...employeeList} />}
        {selected === "invites" && <EmployeeInviteList companySlug={companySlug} {...employeeInviteList} />}
      </div>
    </CompanySettingsLayout>
  );
};

export default CompanyUsersPage;
